export const taskFileGroupMessageTypeDef = `
  id
  text
  createdAt
  cancelledAt
  authorName
`;
